import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TypesModel } from 'common/models/page-models/types/types-data-model';
import { TypesListingModel } from 'common/models/page-models/types/types-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { TypesGridWidgetService } from 'common/widget/types/types-grid-widget.service';

 
@Injectable({
    providedIn: 'root'
})
export class TypesGridResolver extends GridResolver<TypesModel, TypesListingModel> {
    constructor(
        protected fs: TypesGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}